import type { SVGProps } from 'react'

export const CanvaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 80 80"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_905_1790)">
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="#7D2AE7"
      />
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="url(#paint0_radial_905_1790)"
      />
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="url(#paint1_radial_905_1790)"
      />
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="url(#paint2_radial_905_1790)"
      />
      <path
        d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
        fill="url(#paint3_radial_905_1790)"
      />
      <path
        d="M57.2691 48.2052C56.939 48.2052 56.6485 48.484 56.3462 49.0928C52.9323 56.0153 47.0358 60.9134 40.2125 60.9134C32.3228 60.9134 27.437 53.7913 27.437 43.9522C27.437 27.2855 36.7232 17.6491 44.8796 17.6491C48.691 17.6491 51.0186 20.0443 51.0186 23.8559C51.0186 28.3796 48.4485 30.7748 48.4485 32.3702C48.4485 33.0864 48.8939 33.5201 49.7773 33.5201C53.3264 33.5201 57.4918 29.4419 57.4918 23.6808C57.4918 18.0947 52.63 13.9888 44.4737 13.9888C30.994 13.9888 19.0142 26.4858 19.0142 43.777C19.0142 57.1614 26.6572 66.0061 38.45 66.0061C50.9668 66.0061 58.2043 53.5526 58.2043 49.5105C58.2043 48.6153 57.7466 48.2052 57.2691 48.2052Z"
        fill="white"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_905_1790"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.453 70.9057) rotate(-49.416) scale(61.8733)"
      >
        <stop stopColor="#6420FF" />
        <stop offset="1" stopColor="#6420FF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_905_1790"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(21.1788 9.09457) rotate(54.703) scale(69.7735)"
      >
        <stop stopColor="#00C4CC" />
        <stop offset="1" stopColor="#00C4CC" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_905_1790"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.4526 70.9053) rotate(-45.1954) scale(61.1242 28.1118)"
      >
        <stop stopColor="#6420FF" />
        <stop offset="1" stopColor="#6420FF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_905_1790"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.7158 10.7789) rotate(66.5198) scale(62.9836 105.512)"
      >
        <stop stopColor="#00C4CC" stopOpacity="0.725916" />
        <stop offset="0.0001" stopColor="#00C4CC" />
        <stop offset="1" stopColor="#00C4CC" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_905_1790">
        <rect width="80" height="80" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
